import React from "react";
import { LogOut } from "lucide-react";
import AuthIcon from "../../common/auth-icon";

// Image
import logoLight from "assets/images/logo-light.png";
import logoDark from "assets/images/logo-dark.png";
import { Link } from "react-router-dom";

const BasicLogout = () => {
  document.title = "LogOut | Tailwick - React Admin & Dashboard Template";

  React.useEffect(() => {
    const bodyElement = document.body;

    bodyElement.classList.add(
      "flex",
      "items-center",
      "justify-center",
      "min-h-screen",
      "py-16",
      "lg:py-10",
      "bg-slate-50",
      "dark:bg-zink-800",
      "dark:text-zink-100",
      "font-public"
    );

    return () => {
      bodyElement.classList.remove(
        "flex",
        "items-center",
        "justify-center",
        "min-h-screen",
        "py-16",
        "lg:py-10",
        "bg-slate-50",
        "dark:bg-zink-800",
        "dark:text-zink-100",
        "font-public"
      );
    };
  }, []);

  return (
    <React.Fragment>
      <div className="relative">
        <AuthIcon />

        <div className="mb-0 w-screen lg:w-[500px] card shadow-lg border-none shadow-slate-100 dark:shadow-zink-500/20 relative">
          <div className="!px-10 !py-12 card-body">
            <Link to="/">
              <img src={logoLight} alt="" className="hidden h-6 mx-auto dark:block" />
              <img src={logoDark} alt="" className="block h-6 mx-auto dark:hidden" />
            </Link>

            <div className="mt-8 text-center">
              <div className="mb-4 text-center">
                <LogOut className="size-6 mx-auto text-purple-500 fill-purple-100"></LogOut>
              </div>
              <h4 className="mb-2 text-custom-500 dark:text-custom-500">You are Logged Out</h4>
              <p className="mb-8 text-slate-500 dark:text-zink-200">Thank you for using tailwick admin template</p>
            </div>

            <Link
              to="/auth-login-basic"
              className="w-full text-white transition-all duration-200 ease-linear btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            >
              Sign In
            </Link>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BasicLogout;
